import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api, type OrderPageFilter, type OrderQuery } from "@/api";

export const orderKeys = {
	all: ["orders"] as const,
	page: (filter: OrderPageFilter) => ["orders", "page", filter] as const,
	statusCounts: (query: OrderQuery) => ["orders", "status-counts", query] as const,
	shipments: (orderId: string) => ["orders", "shipments", orderId] as const,
	shops: ["orders", "shops"] as const,
};

/** Магазины из заказов — варианты фильтра «Магазин». */
export function useOrderShops() {
	return useQuery({ queryKey: orderKeys.shops, queryFn: () => api.orders.shops() });
}

/** Страница заказов с сервера; прежняя видна, пока грузится следующая. */
export function useOrderPage(filter: OrderPageFilter, enabled = true) {
	return useQuery({
		queryKey: orderKeys.page(filter),
		queryFn: () => api.orders.page(filter),
		placeholderData: keepPreviousData,
		enabled,
	});
}

export function useOrderStatusCounts(query: OrderQuery) {
	return useQuery({
		queryKey: orderKeys.statusCounts(query),
		queryFn: () => api.orders.statusCounts(query),
		placeholderData: keepPreviousData,
	});
}

export function useOrderShipments(orderId: string) {
	return useQuery({
		queryKey: orderKeys.shipments(orderId),
		queryFn: () => api.orders.shipments(orderId),
		enabled: !!orderId,
	});
}

export function useOrderReceipt(orderId: string, enabled: boolean) {
	return useQuery({
		queryKey: ["orders", "receipt", orderId] as const,
		queryFn: () => api.orders.receipt(orderId),
		enabled: enabled && !!orderId,
	});
}
